import cfgDev from './config.development';
import cfgProd from './config.production';

const cfg = {
  refreshDelay: 1000 * 60 * 10,  // 10 minutes
  showShipping: true,

  /**
   * Furniture types
   */
  furnitureTypes: {
    wardrobe: 'Lyne',
    table: 'Tymber',
    shelf: 'Gryd',
    joyn: 'Tyme',
    sydetable: 'Syde'
  },

  /**
   * Furniture types
   */
  furnitureNames: {
    sydetable: 'sidetable',
    joyn: 'sofa',
    pyllow: 'sofa',
    chayr: 'chair',
    pryme: 'chair',
    styng: 'chair',
  },

  /**
   * Countries
   */
  countries: {
    codesToNames: {
      at: 'Austria',
      // be: 'Belgium',
      ch: 'Switzerland',
      de: 'Germany',
      fr: 'France',
      // nl: 'Netherlands',
      uk: 'United Kingdom',
    },

    codesToFlagsUnicode: {
      at: '🇦🇹',
      be: '🇧🇪',
      ch: '🇨🇭',
      de: '🇩🇪',
      fr: '🇫🇷',
      nl: '🇳🇱',
      uk: '🇬🇧',
    },
  },

  /**
   * Following UUIDs are being used for smoke tests
   * (we exclude them from the board)
   */
  blacklist: {
    uuids: [
      '2-3Sg6uue',
      'C-I2cyv6',
      'Cwfj_ZQhc',
      'F-Dzh0R4Z',
      'F-UuQkrFj',
      'FHHKtCpme',
      'FHVFfUw7',
      'FHvyaI18Z',
      'FidD5CQgv',
      'LwAf6LoS',
      'Q-UXOnsIe',
      'QiLf7sN8Z',
      'QiNtE2zhv',
      'QiNtE2zhv',
      'QigwyMFcx',
      'Qw6FJkIFj',
      'Qwqc9ggp9',
      'Twimzb2cj',
      'p-IlYHOXU',
      'pH9dsLAfX',
      'pHEkrYtnZ',
      'piz5-j11e',
      'piz5-j11e',
      'z-eUyzBn9',
      'zHO0SLpgj',
      'zwa-sCQhj',
      'zwxz6TQqv',
    ],
  },
};

const isProd = process.env.NODE_ENV === 'production';
export default Object.assign(cfg, isProd ? cfgProd : cfgDev);



// WEBPACK FOOTER //
// ./src/config/config.default.js